import { portalTabQueryKeys } from "@portal/Components/Portal/PotalTabs/types";
import {
  getCreditMemoDetails,
  getCreditNotesList,
} from "@portal/api/credit-notes-list";
import { CreditFilters } from "@portal/store/Filters/credits/type";
import { tableAtom } from "@portal/store/table/table";
import { RequestConfig } from "@portal/types/common";
import { useQuery } from "@tanstack/react-query";
import produce from "immer";
import { useSetAtom } from "jotai";

function useCreditNotesQuery(params: RequestConfig<CreditFilters>) {
  const setTableValue = useSetAtom(tableAtom);

  return useQuery({
    queryKey: [portalTabQueryKeys.CREDIT_NOTES, params],
    queryFn: () => getCreditNotesList(params),
    retry: false,
    async onSuccess(data) {
      setTableValue((value) => {
        return produce(value, (draft) => {
          draft.bulk_records = data.total_records;
          return draft;
        });
      });
    },
    onError(err) {},
  });
}
function useCreditMemoDetailsQuery(params?: string) {
  return useQuery({
    queryKey: ["credit-notes", params],
    queryFn: () => getCreditMemoDetails(params),
    retry: false,
    enabled: Boolean(params?.length),
  });
}

export { useCreditMemoDetailsQuery, useCreditNotesQuery };
